// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__18Xh5","notes":"Notes_notes__3vf-Z"};